export default __webpack_public_path__ + "static/media/cog-white.5b2e917a.svg";